
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';

const div1 = {
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	height: "inherit",
	padding: "3px"
}

const div2 = {
	width: "80%",
	height: "80%",
	background: "#fff",
	boxShadow: "15px 15px 25px #ccc",
	borderRadius: "15px"
}

const centerText = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
}

class introPersonalityTest extends Component {
	constructor(props) {
		super(props)
		this.state = {
			accessed: false
		}
	}
	onChange(e) {
		this.setState({ [e.target.name]: e.target.value });
	}
	async componentDidMount() {
		await axios.post(`/api/personalityApi/checkIfTestIsAccessedPre/`)
			.then(resp => {
				if (resp.data.message === true) {
					this.setState({ accessed: true })
				}
			})
			.catch(err => {

			})
	}

	render() {
		const accessButton = this.state.accessed === true ?
			(<Link disabled className="btn btn-danger btn-fill col-md-2" >Pređi na test</Link>) :
			(<Link to="/personalityTest" className="btn btn-info btn-fill col-md-2" >Pređi na test</Link>)

		return (
			<div className="Content">
				<div style={div1}>
					<div style={div2}>
						<div style={{ textAlign: "center", margin: "24px 50px 12px" }}>
							<div style={{ padding: "16px 0", textAlign: "left" }}>
								<br /><br />
								Zdravo {this.props.auth.user.name},
								<br /><br />
								Pred Vama se nalazi test ličnosti. Test popunjavate tako što za svako pitanje birate jednu osobinu,
								odnosno jedan red osobina, za koje smatrate da ste to najviše Vi, i jednu osobinu, odnosno jedan red osobina,
								za koje smatrate da ste to najmanje Vi. Dakle, za svako pitanje, mora postojati tačno jedan odgovor u prvoj
								koloni i tačno jedan odgovor u drugoj koloni, pri čemu ovi odgovori ne smeju biti u istom redu. Primer pravilno
								popunjenog odgovora, dat je na slici ispod.
								<br /><br />
								<div style={centerText}>
									<Table striped bordered hover variant="grey" style={{ width: '45%' }}>
										<tbody>
											<tr>
												<td></td><td style={{ textAlign: 'center' }}>Najviše</td><td style={{ textAlign: 'center' }}>Najmanje</td>
											</tr>
											<tr>
												<td>Dobar</td>
												<td style={{ textAlign: 'center' }}>
													<input
														disabled
														onChange={this.onChange}
														type="radio"
														className="form-check-input"
													/>
												</td>
												<td style={{ textAlign: 'center' }}>
													<input
														disabled
														onChange={this.onChange}
														type="radio"
														className="form-check-input"
													/>
												</td>
											</tr>
											<tr>
												<td>Pravedan</td>
												<td style={{ textAlign: 'center' }}>
													<input
														disabled
														checked
														onChange={this.onChange}
														type="radio"
														className="form-check-input"
													/>
												</td>
												<td style={{ textAlign: 'center' }}>
													<input
														disabled
														onChange={this.onChange}
														type="radio"
														className="form-check-input"
													/>
												</td>
											</tr>
											<tr>
												<td>Pošten</td>
												<td style={{ textAlign: 'center' }}>
													<input
														disabled
														onChange={this.onChange}
														type="radio"
														className="form-check-input"
													/>
												</td>
												<td style={{ textAlign: 'center' }}>
													<input
														disabled
														onChange={this.onChange}
														type="radio"
														className="form-check-input"
													/>
												</td>
											</tr>
											<tr>
												<td>Veseo</td>
												<td style={{ textAlign: 'center' }}>
													<input
														disabled
														onChange={this.onChange}
														type="radio"
														className="form-check-input"
													/>
												</td>
												<td style={{ textAlign: 'center' }}>
													<input
														checked
														disabled
														onChange={this.onChange}
														type="radio"
														className="form-check-input"
													/>
												</td>
											</tr>
										</tbody>
									</Table>
								</div>
								<br /><br />
								Ukoliko se iz nekih nepredviđenih razloga (zatvaranje stranice, izlazak iz pretraživača, osvežavanje stranice testa) izlogujete sa testa, javite se na e-mail adresu: {this.props.auth.user.company === "Group" ? "tanja.petrovic@galeb.com" : "jovana.markovic@galeb.com"}.
								<br /><br />
								Za popunjavanje testa imate 10 minuta i na testsu se nalazi 28 pitanja. Nakon što završite popunjavanje,
								potrebno je da kliknete dugme "Prosledi" kako bi se Vaši odgovori sačuvali. Potrebno je da budete potpuno iskreni.
								Nemojte trošiti vreme na preterano razmišljanje, kako Vam ne bi isteklo vreme.
								<br /><br />
								<div style={centerText}>{accessButton}</div>
							</div>
						</div>
					</div>
				</div>
			</div >
		)
	}
}

const mapStateToProps = state => ({
	auth: state.auth,
});

export default connect(
	mapStateToProps,
)(introPersonalityTest);